import React, { useEffect, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { Content, SubContent, Main } from "../../../components/Layout";
import style from "../style.module.css";
import api from "../../../services/api";
import MenuTrainee from "../../../components/MenuTrainee";
import Required from "../../../components/Required";
import Slct from "../../../components/Slct";
import { IntegerNumber, InputDocument, Phone, Cep } from "../../../components/Input";
import DatePicker from "../../../components/DatePicker";
import styleButton from "../../../components/Button/Button.module.css";
import Wizard from "../../../components/Wizard";
import { toast } from "react-toastify";
import Loading from "../../../components/Loading";
import useWrapper from "../../../hooks/useWrapper";
import Button from "../../../components/Button";
import ModalPassword from "../../../components/Modal/modal-password";

export default function TraineeArea() {
  const [profile, setprofile] = useState({});
  const [pageLoaded, setpageLoaded] = useState(false);
  useEffect(() => {
    api
      .get(`trainee/profile?joins=commercials.institution,commercials.course`, config)
      .then(response => {
        setprofile(response.data);
      })
      .then(() => {
        setpageLoaded(true);
      });
  }, []);

  const { config } = useWrapper();

  const [states2, setstates2] = useState();
  const [cities2, setcities2] = useState();
  useEffect(() => {
    api.get("state").then(response => {
      setstates2({
        data: response.data.map(e => ({
          value: e.id,
          label: e.name,
          uf: e.uf,
        })),
        uf: response.data.map(e => ({
          value: e.id,
          label: e.uf,
        })),
      });
    });
  }, []);
  const [passwordModal, setpasswordModal] = useState();

  const [wizard, setwizard] = useState(1);
  const advanceStep = e => {
    let _error = [];
    document.querySelectorAll(".input-empty").forEach(e => {
      e.classList.remove("input-empty");
    });
    if (e > wizard || e === "save") {
      setTimeout(() => {
        if (e >= 2 || e === "save") {
          if (!profile.name) {
            _error.push({ el: "profile.name", wiz: 1 });
          }
          if (!profile.rg) {
            _error.push({ el: "profile.rg", wiz: 1 });
          }
          if (!profile.ssp_state_id || !profile.ssp) {
            _error.push({ el: "profile.ssp_state_id", wiz: 1, parent: true });
            _error.push({ el: "profile.ssp", wiz: 1 });
          }
          if (!profile.cpf) {
            _error.push({ el: "profile.cpf", wiz: 1 });
          }
          if (!profile.date_birth) {
            _error.push({ el: "profile.date_birth", wiz: 1 });
          }
          if (!profile.cell) {
            _error.push({ el: "profile.cell", wiz: 1 });
          }
          if (!profile.email) {
            _error.push({ el: "profile.email", wiz: 1 });
          }
        }
        if (e >= 3 || e === "save") {
          if (!profile.number) {
            _error.push({ el: "profile.number", wiz: 2 });
          }
          if (!profile.cep) {
            _error.push({ el: "profile.cep", wiz: 2 });
          }
          if (!profile.address) {
            _error.push({ el: "profile.address", wiz: 2 });
          }
          if (!profile.district) {
            _error.push({ el: "profile.district", wiz: 2 });
          }
          if (!profile.state_id) {
            _error.push({ el: "profile.state_id", wiz: 2, parent: true });
          }
          if (!profile.city_id) {
            _error.push({ el: "profile.city_id", wiz: 2, parent: true });
          }
          if (!profile.due_date) {
            _error.push({ el: "profile.due_date", wiz: 2, parent: true });
          }
          if (!profile.commercial_id) {
            _error.push({ el: "profile.commercial_id", wiz: 2, parent: true });
          }
        }
        if (_error.length > 0) {
          let _custom_text_el = _error.find(el => el.customText);
          if (_custom_text_el) {
            toast.error(_custom_text_el.customText);
          } else {
            toast.error("Preencha todos os dados obrigatórios!");
          }
          setwizard(_error[0].wiz);
          setTimeout(() => {
            _error.forEach(er => {
              if (er.wiz === _error[0].wiz && er.el) {
                if (er.parent) {
                  document.querySelectorAll(`*[name="${er.el}"]`).forEach(el => {
                    el.parentElement.classList.add("input-empty");
                  });
                } else {
                  document.querySelectorAll(`*[name="${er.el}"]`).forEach(el => {
                    el.classList.add("input-empty");
                  });
                }
              }
            });
          }, 200);
        } else {
          if (e === "save") {
            const submit_content = {
              name: profile.name,
              email: profile.email,
              instagram: profile.instagram,
              cpf: profile.cpf,
              rg: profile.rg,
              ssp: profile.ssp,
              marital_status: profile.marital_status,
              gender: profile.gender,
              date_birth: profile.date_birth,
              phone: profile.phone,
              cell: profile.cell,
              legal_responsible1: profile.legal_responsible1,
              legal_cell1: profile.legal_cell1,
              legal_responsible2: profile.legal_responsible2,
              legal_cell2: profile.legal_cell2,
              cep: profile.cep,
              number: profile.number,
              address: profile.address,
              district: profile.district,
              complement: profile.complement,
              city_id: profile.city_id,
              state_id: profile.state_id,
              due_date: profile.due_date,
              qtd_invitations: null,
              class_code: null,
              commercial_id: profile.commercial_id,
              year: profile.commercials.year,
              institution_id: profile.commercials.institution.id,
              courser_id: profile.commercials.course.id,
              is_whatsapp: profile.is_whatsapp,
              ssp_state_id: profile.ssp_state_id,
            };
            api.put(`trainee/trainees/${profile.id}`, submit_content, config).then(() => {
              toast.success(`Seus dados foram atualizados com sucesso!`);
            });
          } else {
            setwizard(e);
          }
        }
      }, 20);
    } else {
      setwizard(e);
    }
    // setwizard(e);
  };

  useEffect(() => {
    profile.state_id &&
      api.get(`cities/${profile.state_id}`).then(response => {
        setcities2(
          response.data.map(e => ({
            value: e.id,
            label: e.name,
          })),
        );
      });
  }, [profile.state_id]);

  return (
    <>
      <Main className={style.mainUser}>
        <Content noBG="true">
          <Row>
            <Col md={12} lg={2}>
              <MenuTrainee />
            </Col>
            <Col>
              {pageLoaded ? (
                <SubContent>
                  <Row className="mb-3">
                    <Col>
                      <Wizard
                        selected={wizard}
                        options={[
                          { label: "Dados de Cadastro", onClick: () => advanceStep(1) },
                          { label: "Dados Complementares", onClick: () => advanceStep(2) },
                        ]}
                      />
                    </Col>
                  </Row>
                  {wizard === 1 && (
                    <>
                      <Row>
                        <Col sm={6}>
                          <Form.Group>
                            <span className="lince-input_label">
                              Nome Completo <Required />
                            </span>
                            <Form.Control disabled={true} value={profile.name || ""} name="profile.name" />
                          </Form.Group>
                        </Col>
                        <Col sm={3}>
                          <Form.Group>
                            <span className="lince-input_label">Telefone</span>
                            <Phone
                              name="profile.phone"
                              value={profile.phone || ""}
                              valueChange={ev => {
                                setprofile({
                                  ...profile,
                                  phone: ev,
                                });
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col sm={3}>
                          <Form.Group>
                            <span className="lince-input_label">
                              Celular <Required />
                            </span>
                            <Phone
                              name="profile.cell"
                              value={profile.cell || ""}
                              valueChange={ev => {
                                setprofile({
                                  ...profile,
                                  cell: ev,
                                });
                              }}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col sm={3}>
                          <Form.Group>
                            <span className="lince-input_label">
                              RG <Required />
                            </span>
                            <IntegerNumber
                              name="profile.rg"
                              value={profile.rg || ""}
                              valueChange={ev => {
                                setprofile({
                                  ...profile,
                                  rg: ev,
                                });
                              }}
                              maxLength={20}
                              disabled={true}
                            />
                          </Form.Group>
                        </Col>
                        <Col className="flex" sm={3}>
                          <Row className="ano-periodo">
                            <Col sm={8} className="pr-0">
                              <span className="lince-input_label mb-1">
                                Orgão Emissor <Required />
                              </span>
                              <div className="lince-input__text">
                                <Form.Control
                                  name="profile.ssp"
                                  value={profile.ssp}
                                  maxLength={6}
                                  onChange={ev => {
                                    setprofile({
                                      ...profile,
                                      ssp: ev.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </Col>
                            <Col className="d-flex align-items-end pl-0">
                              <Slct
                                name="profile.ssp_state_id"
                                className={`w-100`}
                                options={states2 ? states2.uf : []}
                                value={profile.ssp_state_id || ""}
                                onChange={e => {
                                  setprofile({
                                    ...profile,
                                    ssp_state_id: parseInt(e.value),
                                  });
                                }}
                                placeholder="..."
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col sm={3}>
                          <span className="lince-input_label">Estado Civil</span>
                          <Slct
                            name="profile.marital_status"
                            options={[
                              { label: "Solteiro(a)", value: "solteiro" },
                              { label: "Casado(a)", value: "casado" },
                            ]}
                            value={profile.marital_status || ""}
                            onChange={e => {
                              setprofile({
                                ...profile,
                                marital_status: e.value,
                              });
                            }}
                            placeholder="..."
                          />
                        </Col>
                        <Col sm={3}>
                          <Form.Group className="lince-input">
                            <span className="lince-input_label">
                              CPF <Required />
                            </span>
                            <div className="lince-input__text">
                              <InputDocument
                                name="profile.cpf"
                                value={profile.cpf || ""}
                                type="cpf"
                                valueChange={ev => {
                                  setprofile({
                                    ...profile,
                                    cpf: ev,
                                  });
                                }}
                                disabled={true}
                              />
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col sm={3}>
                          <span className="lince-input_label">Gênero</span>
                          <Slct
                            name="profile.gender"
                            options={[
                              { label: "Masculino", value: "M" },
                              { label: "Feminino", value: "F" },
                              { label: "Prefiro não informar", value: "NI" },
                            ]}
                            value={profile.gender || ""}
                            onChange={ev => {
                              setprofile({
                                ...profile,
                                gender: ev.value,
                              });
                            }}
                            disabled={true}
                            placeholder="..."
                          />
                        </Col>
                        <Col sm={3}>
                          <Form.Group className="d-flex flex-column">
                            <span className="lince-input_label">
                              Nascimento <Required />
                            </span>
                            <DatePicker
                              name="profile.date_birth"
                              selected={new Date(profile.date_birth) || null}
                              changeDate={ev => {
                                setprofile({
                                  ...profile,
                                  date_birth: ev,
                                });
                              }}
                              disabled={true}
                            />
                          </Form.Group>
                        </Col>
                        <Col sm={3}>
                          <Form.Group className="lince-input">
                            <span className="lince-input_label">
                              Email <Required />
                            </span>
                            <div className="lince-input__text">
                              <Form.Control
                                name="profile.email"
                                value={profile.email || ""}
                                disabled={true}
                                onChange={ev => {
                                  setprofile({
                                    ...profile,
                                    email: ev.target.value,
                                  });
                                }}
                              />
                            </div>
                          </Form.Group>
                        </Col>
                        <Col sm={3}>
                          <Form.Group className="lince-input">
                            <span className="lince-input_label">Instagram</span>
                            <div className="lince-input__text">
                              <Form.Control
                                name="profile.instagram"
                                value={profile.instagram}
                                onChange={ev => {
                                  setprofile({
                                    ...profile,
                                    instagram: ev.target.value,
                                  });
                                }}
                              />
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col sm={3}>
                          <Form.Group className="lince-input">
                            <span className="lince-input_label">Responsável Legal 1</span>
                            <div className="lince-input__text">
                              <Form.Control
                                type="text"
                                value={profile.legal_responsible1}
                                onChange={ev => {
                                  setprofile({
                                    ...profile,
                                    legal_responsible1: ev.target.value,
                                  });
                                }}
                              />
                            </div>
                          </Form.Group>
                        </Col>
                        <Col sm={3}>
                          <Form.Group className="lince-input">
                            <span className="lince-input_label">Celular Responsável 1</span>
                            <div className="lince-input__text">
                              <Phone
                                value={profile.legal_cell1}
                                valueChange={ev => {
                                  setprofile({
                                    ...profile,
                                    legal_cell1: ev,
                                  });
                                }}
                              />
                            </div>
                          </Form.Group>
                        </Col>
                        <Col sm={3}>
                          <Form.Group className="lince-input">
                            <span className="lince-input_label">Responsável Legal 2</span>
                            <div className="lince-input__text">
                              <Form.Control
                                type="text"
                                value={profile.legal_responsible2}
                                onChange={ev => {
                                  setprofile({
                                    ...profile,
                                    legal_responsible2: ev.target.value,
                                  });
                                }}
                              />
                            </div>
                          </Form.Group>
                        </Col>
                        <Col sm={3}>
                          <Form.Group className="lince-input">
                            <span className="lince-input_label">Celular Responsável 2</span>
                            <div className="lince-input__text">
                              <Phone
                                value={profile.legal_cell2}
                                valueChange={ev => {
                                  setprofile({
                                    ...profile,
                                    legal_cell2: ev,
                                  });
                                }}
                              />
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                    </>
                  )}
                  {wizard === 2 && (
                    <>
                      <Row>
                        <Col sm={3}>
                          <Form.Group className="lince-input nav-input">
                            <span className="lince-input_label">
                              CEP <Required />
                            </span>
                            <a
                              href="https://buscacepinter.correios.com.br/app/endereco/index.php?t"
                              rel="noopener noreferrer"
                              target="_blank"
                              className="im-nav"
                            >
                              Buscar CEP
                            </a>
                            <div className="lince-input__text">
                              <Cep
                                value={profile.cep}
                                name="profile.cep"
                                valueChange={ev => {
                                  setprofile({
                                    ...profile,
                                    cep: ev,
                                  });
                                }}
                                onBlur={() => {
                                  if (String(profile.cep).length >= 8) {
                                    api.get(`https://viacep.com.br/ws/${profile.cep}/json/`).then(response => {
                                      if (!response.data.erro) {
                                        let _state = states2.data.find(e => e.uf === response.data.uf) || null;
                                        api.get(`cities/${_state.value}`).then(response2 => {
                                          let _city =
                                            response2.data.find(e => e.name === response.data.localidade) || null;
                                          setprofile({
                                            ...profile,
                                            address: response.data.logradouro,
                                            district: response.data.bairro,
                                            city_id: _city.id,
                                            state_id: _city.state_id,
                                          });
                                        });
                                      }
                                    });
                                  }
                                }}
                              />
                            </div>
                          </Form.Group>
                        </Col>
                        <Col sm={3}>
                          <Form.Group className="lince-input">
                            <span className="lince-input_label">
                              Número <Required />
                            </span>
                            <div className="lince-input__text">
                              <IntegerNumber
                                type="text"
                                name="profile.number"
                                value={profile.number}
                                valueChange={ev => {
                                  setprofile({
                                    ...profile,
                                    number: ev,
                                  });
                                }}
                                maxLength={5}
                              />
                            </div>
                          </Form.Group>
                        </Col>
                        <Col sm={6}>
                          <Form.Group className="lince-input">
                            <span className="lince-input_label">
                              Endereço <Required />
                            </span>
                            <div className="lince-input__text">
                              <Form.Control
                                type="text"
                                value={profile.address}
                                name="profile.address"
                                onChange={ev => {
                                  setprofile({
                                    ...profile,
                                    address: ev.target.value,
                                  });
                                }}
                              />
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col sm={3}>
                          <Form.Group className="lince-input">
                            <span className="lince-input_label">
                              Bairro <Required />
                            </span>
                            <div className="lince-input__text">
                              <Form.Control
                                type="text"
                                value={profile.district}
                                name="profile.district"
                                onChange={ev => {
                                  setprofile({
                                    ...profile,
                                    district: ev.target.value,
                                  });
                                }}
                              />
                            </div>
                          </Form.Group>
                        </Col>
                        <Col sm={3}>
                          <Form.Group className="lince-input">
                            <span className="lince-input_label">Complemento</span>
                            <div className="lince-input__text">
                              <Form.Control
                                type="text"
                                value={profile.complement}
                                onChange={ev => {
                                  setprofile({
                                    ...profile,
                                    complement: ev.target.value,
                                  });
                                }}
                              />
                            </div>
                          </Form.Group>
                        </Col>
                        <Col sm={3}>
                          <Form.Group>
                            <span className="lince-input_label">
                              Estado <Required />
                            </span>
                            <Slct
                              options={states2 ? states2.data : []}
                              value={profile.state_id || ""}
                              name="profile.state_id"
                              onChange={ev => {
                                setprofile({
                                  ...profile,
                                  state_id: ev.value,
                                  city_id: null,
                                });
                              }}
                              placeholder="..."
                            />
                          </Form.Group>
                        </Col>
                        <Col sm={3}>
                          <Form.Group>
                            <span className="lince-input_label">
                              Cidade <Required />
                            </span>
                            <Slct
                              options={cities2 || []}
                              value={profile.city_id || ""}
                              name="profile.city_id"
                              onChange={ev => {
                                setprofile({
                                  ...profile,
                                  city_id: ev.value,
                                });
                              }}
                              placeholder="..."
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </>
                  )}
                  <Row className="mt-4">
                    <Col>
                      <Button
                        onClick={() => {
                          setpasswordModal(true);
                        }}
                        color="grey_ghost"
                      >
                        Alterar Senha
                      </Button>
                    </Col>
                    <Col className="d-flex justify-content-end">
                      {wizard <= 1 && (
                        <Button
                          onClick={() => {
                            advanceStep(wizard + 1);
                          }}
                          color="primary_ghost"
                        >
                          Avançar
                        </Button>
                      )}
                      {wizard > 1 && (
                        <Button
                          onClick={() => {
                            advanceStep(wizard - 1);
                          }}
                          color="primary_ghost"
                        >
                          Voltar
                        </Button>
                      )}
                      {wizard === 2 && (
                        <button
                          type="button"
                          className={`ml-2 ${styleButton.button_primary}`}
                          onClick={() => advanceStep("save")}
                        >
                          Salvar
                        </button>
                      )}
                    </Col>
                  </Row>
                </SubContent>
              ) : (
                <SubContent>
                  <Loading />
                </SubContent>
              )}
            </Col>
          </Row>
        </Content>
      </Main>
      <ModalPassword show={passwordModal} onHide={() => setpasswordModal(false)} />
    </>
  );
}
